export const getPriorityLabel = (priority: number) => {
  // TODO #22334: Update/Verify API priority strings are correct
  switch (priority) {
    case 0:
      return 'Urgent';
    case 1:
      return 'High';
    case 2:
      return 'Medium';
    case 3:
      return 'Low';
    default:
      return '';
  }
};
